<template>
    <v-row class="pb-4">
        <v-col cols="12" class="text-body-2 d-flex justify-space-between align-center">
            Clients
        </v-col>
        <v-col>
          <v-data-table
              :headers="headers"
              :items="items"
              disable-pagination
              class="elevation-1"
              hide-default-header
              hide-default-footer
              @click:row="handleClick"
              dense
          ></v-data-table>
        </v-col>
    </v-row>
</template>

<script>
import {REACT_URL} from "@/common/config-local";

export default {
    data: () => {
      return {
        headers: [
          {
            text: 'name',
            value: 'displayName',
          },
          {
            text: 'email',
            value: 'email',
          },
        ]
      }
    },
    props:{
        items:{
            type: Array,
            required:true
        },
        type: {
            type: String,
            default: () => 'all'
        }
    },
    methods:{
        open(id){
            this.$emit('close')
            window.location.href = `${REACT_URL}/clients/${id}`;
        },
      handleClick(item) {
        this.open(item.id)
      },
    }
}
</script>